import * as React from "react";

import { Skeleton } from "@replo/design-system/components/skeleton/Skeleton";

type HeaderProps = {
  title: string | null;
  subtitle?: string;
  isLoading?: boolean;
  endEnhancer?: React.ReactNode;
  size?: "base" | "sm";
};

const Header: React.FC<HeaderProps> = ({
  title,
  subtitle,
  isLoading,
  endEnhancer,
  size = "base",
}) => {
  return (
    <div className="flex w-full items-center justify-between">
      <div className="flex flex-col gap-2">
        {isLoading && (
          <>
            <div className="h-[30px w-[200px]">
              <Skeleton className="h-[28px] w-[200px]" />
            </div>
            <div className="h-[20px] w-[400px]">
              <Skeleton className="h-[18px] w-[400px]" />
            </div>
          </>
        )}
        {!isLoading && title && size === "base" ? (
          <h2 className="header-h4 text-default break-words">{title}</h2>
        ) : (
          <h3 className="header-h5 text-default break-words">{title}</h3>
        )}

        {!isLoading && subtitle && (
          <p className="text-muted text-sm break-words leading-relaxed">
            {subtitle}
          </p>
        )}
      </div>
      {endEnhancer}
    </div>
  );
};

export default Header;
